import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Loader from 'components/Loader';

import { formatEmptyValue } from '../../../../helpers/formatters';
import { formatCurrency } from '../../../../helpers/converters';

const Resume = ({ resume, totalOs, isMobile, isLoading }) => {
  if(isMobile) {
    return(
      <Paper style={{ marginBottom: 20, padding: 5 }}>
        <Loader isLoading={isLoading}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>Faturamento</b>
                </Typography>
                <Typography>
                  {formatCurrency(resume.totalAmount)}
                </Typography>
              </Grid>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>OS Paga</b>
                </Typography>
                <Typography>
                  {formatEmptyValue(resume.totalPaid)}
                </Typography>
              </Grid>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>Ticket médio</b>
                </Typography>
                <Typography>
                  {formatCurrency(+resume.totalAmount / +resume.totalPaid)}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ borderLeft: '1px solid #D7D7D7' }}>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>Total de OS</b>
                </Typography>
                <Typography>
                  {formatEmptyValue(totalOs)}
                </Typography>
              </Grid>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>OS Canceladas</b>
                </Typography>
                <Typography>
                  {formatEmptyValue(resume.totalSoCanceled)}
                </Typography>
              </Grid>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>OS Alteradas</b>
                </Typography>
                <Typography>
                  {formatEmptyValue(resume.totalUpdated)}
                </Typography>
              </Grid>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>OS Isentas</b>
                </Typography>
                <Typography>
                  {formatEmptyValue(resume.totalFreeSituations)}
                </Typography>
              </Grid>
              <Grid container justify='space-between' alignItems='center'>
                <Typography color='primary'>
                  <b>Período médio</b>
                </Typography>
                <Typography>
                  {
                    resume.averagePeriod
                      ? formatEmptyValue(moment.duration(parseFloat(resume.averagePeriod), 'seconds').format('D [dia(s)], H [h e] m [min]'))
                      : 'Sem período'
                  }
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Loader>
      </Paper>
    );
  }

  return(
    <Paper style={{ marginBottom: 20 }}>
      <Loader isLoading={isLoading}>
        <Grid container>
          <Grid item xs={4}>
            <Grid container>
              <Grid item xs={12} style={{ borderBottom: '5px solid #13BC4B', padding: 10 }}>
                <Grid container justify='space-between' alignItems='center'>
                  <Typography color='primary'>
                    <b>Faturamento</b>
                  </Typography>
                  <Typography>
                    {formatCurrency(resume.totalAmount)}
                  </Typography>
                </Grid>
                <Grid container justify='space-between' alignItems='center'>
                  <Typography color='primary'>
                    <b>OS Paga</b>
                  </Typography>
                  <Typography>
                    {formatEmptyValue(resume.totalPaid)}
                  </Typography>
                </Grid>
                <Grid container justify='space-between' alignItems='center'>
                  <Typography color='primary'>
                    <b>Ticket médio</b>
                  </Typography>
                  <Typography>
                    {formatCurrency(+resume.totalAmount / +resume.totalPaid)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={8}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={2} style={{ borderLeft: '1px solid #D7D7D7' }}>
                <Grid container direction='column' justify='center' alignItems='center' style={{ borderBottom: '5px solid #022A5C', height: '100%' }}>
                  <Typography color='primary'>
                    <b>Total de OS</b>
                  </Typography>
                  <Typography>
                    {formatEmptyValue(totalOs)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={2} style={{ borderLeft: '1px solid #D7D7D7' }}>
                <Grid container direction='column' justify='center' alignItems='center' style={{ borderBottom: '5px solid #F5B941', height: '100%' }}>
                  <Typography color='primary'>
                    <b>OS Alteradas</b>
                  </Typography>
                  <Typography>
                    {formatEmptyValue(resume.totalUpdated)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={2} style={{ borderLeft: '1px solid #D7D7D7' }}>
                <Grid container direction='column' justify='center' alignItems='center' style={{ borderBottom: '5px solid #F66C6B', height: '100%' }}>
                  <Typography color='primary'>
                    <b>OS Canceladas</b>
                  </Typography>
                  <Typography>
                    {formatEmptyValue(resume.totalSoCanceled)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={2} style={{ borderLeft: '1px solid #D7D7D7' }}>
                <Grid container direction='column' justify='center' alignItems='center' style={{ borderBottom: '5px solid #757575', height: '100%' }}>
                  <Typography color='primary'>
                    <b>OS Isentas</b>
                  </Typography>
                  <Typography>
                    {formatEmptyValue(resume.totalFreeSituations)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={4} style={{ borderLeft: '1px solid #D7D7D7' }}>
                <Grid container direction='column' justify='center' alignItems='center' style={{ height: '100%' }}>
                  <Typography color='primary'>
                    <b>Período médio</b>
                  </Typography>
                  <Typography>
                    {
                      resume.averagePeriod
                        ? formatEmptyValue(moment.duration(parseFloat(resume.averagePeriod), 'seconds').format('D [dia(s)], H [h e] m [min]'))
                        : 'Sem período'
                    }
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Loader>
    </Paper>
  );
}

Resume.defaultProps = {
  resume: null
};

Resume.propTypes = {
  resume: PropTypes.shape({
    totalAmount: PropTypes.number,
    totalPaid: PropTypes.number,
    totalUpdated: PropTypes.number,
    totalSoCanceled: PropTypes.number,
    averagePeriod: PropTypes.number
  })
};

export default Resume;